import * as React from 'react';
import { connect } from 'react-redux';

import DeliverableMediaBlank from './DeliverableMediaBlank';
import MediaPostForm from './MediaPostForm';

import { createDeliverablePost } from 'modules/subcampaigns/reducers/offerDeliverables';

import { t } from 'utils/language';

import type {
  DeliverableUploadTrackingStep,
  DeliverableUploadTrackingType,
  PromiseAction
} from 'types';

type OwnProps = {
  canUpload: boolean,
  offerId: number,
  deliverableId: number,
  placeholder: string,
  postUrlValidator: (b: string, a: string) => any,
  normalizePostUrl: (a: string) => string,
  onUpdate?: () => void,
  onUploadModeTracking: (b: DeliverableUploadTrackingType, a: DeliverableUploadTrackingStep) => void
};

type DispatchProps = {
  dispatchCreatePost: (c: number, b: number, a: string) => PromiseAction
};

type Props = OwnProps & DispatchProps;

type State = {
  errorMessage: string | undefined | null
};

class DeliverableMediaPostForm extends React.PureComponent<Props, State> {
  state = {
    errorMessage: null
  };

  handleDeleteErrorMessage = () => {
    this.setState({
      errorMessage: null
    });
  };

  handleSubmit = (url: string) => {
    const {
      offerId,
      deliverableId,
      dispatchCreatePost,
      normalizePostUrl,
      onUpdate,
      onUploadModeTracking
    } = this.props;

    dispatchCreatePost(offerId, deliverableId, normalizePostUrl(url))
      .then(() => {
        onUploadModeTracking('post', 'upload');

        if (onUpdate) {
          onUpdate();
        }
      })
      .catch((error) => {
        onUploadModeTracking('post', 'upload');

        this.setState({
          errorMessage: error?.response?.status === 409 ? t('campaign_subcampaign_duplicate_post') : t('unknown_error')
        });
      });
  };

  render(): React.ReactNode {
    const { canUpload, postUrlValidator, placeholder } = this.props;
    const { errorMessage } = this.state;

    if (!canUpload) {
      return (
        <DeliverableMediaBlank />
      );
    }

    return (
      <MediaPostForm
        placeholder={placeholder}
        postUrlValidator={postUrlValidator}
        onSubmit={this.handleSubmit}
        onUpdate={this.handleDeleteErrorMessage}
      >
        {
          errorMessage ? (
            <span className="deliverable-media-post-form__error">
              {errorMessage}
            </span>
          ) : null
        }
      </MediaPostForm>
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchCreatePost: (offerId: number, deliverableId: number, url: string) => (
    dispatch(createDeliverablePost(offerId, deliverableId, url))
  )
});

export default connect(null, mapDispatchToProps)(DeliverableMediaPostForm);
